"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Modal = void 0;
var tailwind_1 = require("../constants/tailwind");
var CLASSES = {
    modalOpenButton: 'js-modal-open',
};
/**
 * モーダルを制御するクラス
 */
var Modal = /** @class */ (function () {
    /**
     * コンストラクタ
     * @param {ModalStrategy} strategy クライアントで差し替え可能な処理群
     */
    function Modal(strategy) {
        this.domParser = new DOMParser();
        this.root = document.createElement('div');
        this.init(strategy);
    }
    /**
     * モーダルの初期化
     * @param {ModalStrategy} strategy クライアントで差し替え可能な処理群
     */
    Modal.prototype.init = function (strategy) {
        var _a;
        var _this = this;
        // モーダルのポータルを作成
        (_a = this.root.classList).add.apply(_a, tailwind_1.TAILWIND_CLASSES.MODAL);
        document.body.appendChild(this.root);
        // モーダルを開くクリックイベントを作成
        var modalOpenButtons = document.querySelectorAll(".".concat(CLASSES.modalOpenButton));
        modalOpenButtons.forEach(function (button) {
            button.addEventListener('click', function () {
                var contents = strategy.createContents(button);
                _this.open(contents);
            });
        });
    };
    /**
     * モーダルを開く
     * @param {string} contentsTemplate モーダルに表示するコンテンツテンプレート
     */
    Modal.prototype.open = function (contentsTemplate) {
        var _this = this;
        // クラスを追加して表示
        var doc = this.domParser.parseFromString(contentsTemplate, 'text/html');
        var contents = doc.body.firstChild;
        contents.classList.add(tailwind_1.TAILWIND_CLASSES.Z_1);
        // DOMにマウント
        var overlay = this.createOverlay();
        this.root.insertAdjacentElement('afterbegin', overlay);
        this.root.insertAdjacentElement('beforeend', contents);
        // アニメーション
        this.root.classList.remove(tailwind_1.TAILWIND_CLASSES.HIDDEN);
        this.root.classList.add(tailwind_1.TAILWIND_CLASSES.FLEX);
        requestAnimationFrame(function () {
            _this.root.classList.remove(tailwind_1.TAILWIND_CLASSES.OPACITY_0);
        });
    };
    /**
     * モーダルを閉じる
     */
    Modal.prototype.close = function () {
        var _this = this;
        // アニメーション
        requestAnimationFrame(function () {
            _this.root.classList.add(tailwind_1.TAILWIND_CLASSES.OPACITY_0);
            setTimeout(function () {
                _this.root.innerHTML = '';
                _this.root.classList.remove(tailwind_1.TAILWIND_CLASSES.FLEX);
                _this.root.classList.add(tailwind_1.TAILWIND_CLASSES.HIDDEN);
            }, 300); // アニメーションの時間に合わせて調整
        });
    };
    /**
     * モーダルのオーバーレイを作成
     * @returns {HTMLElement} モーダルのオーバーレイ要素
     */
    Modal.prototype.createOverlay = function () {
        var overlayTemplate = "\n    <div class=\"".concat(tailwind_1.TAILWIND_CLASSES.MODAL_OVERLAY.join(' '), "\"></div>\n    ");
        var doc = this.domParser.parseFromString(overlayTemplate, 'text/html');
        var overlay = doc.body.firstChild;
        // クリックで閉じないようにイベントリスナーを削除
        // overlay.addEventListener('click', () => {
        //   this.close();
        // });
        return overlay;
    };
    return Modal;
}());
exports.Modal = Modal;
